<template>
    <div class="row">
        <div class="col-12" :class="{ 'col-xl-9': !inCheckout }">

            <el-form @submit="submit()" :error="server_error" :loading="loading" :disabled="loading" :success="success" :button-text="`${$options.name}.button`">

                <h2 v-if="!inCheckout" class="mb-30 fw-b fs-24">{{ $t(`${$options.name}.title`) }}</h2>

                <div class="form-row">
                    <el-input class="col-12 col-lg-6 mb-30" v-model="localWorkspace.company" name="company" rule="required" />
                    <el-input class="col-12 col-lg-6 mb-30" v-model="localWorkspace.vat" @input="handleVATUpdate" name="vat_number" rule="required|min:10|max:14" />
                    <el-input class="col-12 col-lg-8 mb-15" v-model="localWorkspace.street" name="street" rule="required" />
                    <el-input class="col-12 col-lg-4 mb-15" v-model="localWorkspace.number" name="number" rule="required" />
                    <el-input class="col-12 col-lg-4 mb-0" v-model="localWorkspace.zip" name="zip" rule="required" :hasLabel="false" />
                    <el-input class="col-12 col-lg-8 mb-0" v-model="localWorkspace.city" name="city" rule="required" :hasLabel="false" />
                </div>

            </el-form>

            <el-form v-if="!inCheckout" @submit="submit()" :error="server_error" :loading="loading" :disabled="loading" :success="success" :button-text="`${$options.name}.button`">

                <h3 class="mb-10 fw-b fs-20">{{ $t(`${$options.name}.workspace`) }}</h3>
                <p v-if="!alterWorkspaceName" class="mb-0 fs-15 fw-n ff-l text-light">
                    <span class="fw-b ff-l fs-17 text-secondary">{{ localWorkspace.slug }}</span>.appvalvas.com
                    <span class="text-primary c-pointer fs-11 ml-15" @click="alterWorkspaceName = true">
                        {{ $t(`${$options.name}.change_domain`) }}
                    </span>
                </p>
                <template v-if="alterWorkspaceName">
                    <div class="form-row mb-10">
                        <p class="col-12 mb-15 fs-15 fw-n ff-l text-light">{{ $t(`${$options.name}.workspace_description`) }}</p>
                        <el-input v-model="localWorkspace.name" class="col-12 col-lg-5 mb-0" rule="required|min:2|max:255" @input="suggestDomain" name="onboarding_workspace_title" :hasLabel="false" />
                        <el-input class="col-12 col-lg-5 mb-0" v-model="localWorkspace.slug" @input="v => { check(); localWorkspace.slug = slugify(v)} " type="text" name="workspace" rule="required|min:2|max:255" :hasLabel="false"></el-input>
                        <button class="col btn btn-primary" @click="submit" :disabled="exists || loading">Wijzigen <i-loader v-if="loading" class="i-15 va-tb ml-10"></i-loader></button>
                    </div>
                    <div v-if="localWorkspace.name.length > 0">
                        <div v-if="!exists" class="fs-11 text-primary">
                            <i-check class="i-13 mr-5 fill-primary"></i-check> {{ $t(`${$options.name}.workspace_available`) }}
                        </div>
                        <div v-else class="fs-11 text-danger">
                            <i-close class="i-13 mr-5 fill-danger"></i-close> {{ $t(`${$options.name}.workspace_unavailable`) }}
                        </div>
                    </div>
                </template>

                <template #footerRight>
                    &#160;
                </template>

            </el-form>

            <div v-if="!inCheckout" class="">
                <h3 class="mb-10 fw-b fs-15">{{ $t(`${$options.name}.users`) }}</h3>
                <p class="text-muted my-15">{{ $t(`${$options.name}.users_sub`) }}</p>
                <div>
                    <router-link :to="{ name: 'workspace-users' }" class="d-flex">
                        <el-participants class="my-auto" :users="workspace.users" :canEdit="false"></el-participants>
                        <a href="#" class="btn ml-15 btn-outline-primary" v-html="$t(`${$options.name}.invite_users`)"></a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _ } from "vue-underscore";
import { ElParticipants } from "@/components/elements/_index";

import HasForm from '@/components/forms/has-form';

export default {
    name: 'views.profile.company',

    mixins: [HasForm],

    components: {
        ElParticipants,
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm"),
        ElInput: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElInput")
    },

    props: {
        inCheckout: {
            default: false,
        }
    },

    data() {
        return {
            localWorkspace: {
                company: "",
                vat: "",
                street: "",
                number: "",
                zip: "",
                city: "",
                name: "",
                slug: ""
            },
            exists: false,
            alterWorkspaceName: false,
        };
    },
    mounted() {
        this.localWorkspace.company = this.workspace.company;
        this.localWorkspace.vat = this.workspace.vat;
        this.localWorkspace.street = this.workspace.street;
        this.localWorkspace.number = this.workspace.number;
        this.localWorkspace.zip = this.workspace.zip;
        this.localWorkspace.city = this.workspace.city;
        this.localWorkspace.name = this.workspace.name;
        this.localWorkspace.slug = this.workspace.slug;
    },
    methods: {

        check: _.debounce(function() {
            this.$store.dispatch('workspace/verify', this.localWorkspace).then(res => {
                this.exists = res.exists;
            });
        }, 500),

        suggestDomain() {
            this.localWorkspace.slug = this.slugify(this.localWorkspace.name);

            this.check();
        },


        /*
        | Debounce check
        | ------------------
        | Handles the form submission
        | but only after typing has stopped for x seconds
        */
        handleVATUpdate: _.debounce(function() {
            if (this.localWorkspace.vat.length >= 10 && this.localWorkspace.vat.length <= 14) {
                this.loading = true
                this.$store.dispatch('workspace/verifyVat', this.localWorkspace.vat)
                    .then((response) => {

                        if (response.valid) {
                            this.localWorkspace.street = response.address.street;
                            this.localWorkspace.number = response.address.number;
                            this.localWorkspace.zip = response.address.zip_code;
                            this.localWorkspace.city = response.address.city;

                        } else {
                            this.handleError({ error: this.$t('user.company.btw_error') })
                        }
                    })
                    .catch(e => this.handleError(e))
                    .finally(() => this.loading = false)
            }
        }, 1500),

        submit() {
            this.loading = true

            let obj = {};
            for (var index in this.localWorkspace) {
                if (this.localWorkspace[index] !== "" && this.localWorkspace[index] !== null) {
                    obj[index] = this.localWorkspace[index]
                }
            }

            this.$store.dispatch('workspace/update', { workspace_id: this.workspace.id, workspace: obj })
                .then(() => {
                    this.alterWorkspaceName = false
                    this.handleSuccess({ toast: true, toast_text: this.$t('toast.workspace.updated') })
                })
                .catch(e => this.handleError(e));
        },

        isValid() {
            return this.$validator.validateAll();
        },

        isValidVat() {
            return this.$store.dispatch('workspace/verifyVat', this.localWorkspace.vat)
        },
    },
    computed: {
        workspace() {
            return this.$store.getters['workspace/current']
        }
    }
};
</script>
